import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { IToastData } from "../../components/playbook-toast/playbook-toast.component";

@Injectable({
  providedIn: "root",
})
export class PlaybookToastService {
  public open = new Subject<IToastData>();

  displayToast(data: IToastData) {
    this.open.next(data);
  }
}
